import { TabChoices } from "routing/constants";
import { User } from "types/users";

export function tabIsAccessible(tabChoice: string, user?: User) {
  const canViewAdmin = !!user?.is_superuser; // Admins are allowed to see any tab
  const canViewRegular = !!user && user.username !== "" && !user.only_labeler_ui; // Non-labelers can see regular tabs
  const canViewReview = !!user; // Any logged-in user can see review tab
  const canViewDisagreements = !!user && user.show_disagreements_management; // Show Disagreements management based on flag
  const canViewLabelersManagement = !!user && user.show_labelers_management; // Show Labelers management based on flag

  // TODO: better authz permissions so we don't have long boolean chains like this
  // Probably should be handled on the server
  switch (tabChoice) {
    case TabChoices.Admin:
      return canViewAdmin;
    case TabChoices.Review:
      return canViewReview;
    case TabChoices.Disagreement:
      return canViewDisagreements;
    case TabChoices.Management:
      return canViewLabelersManagement;
    default:
      return canViewRegular;
  }
}
